import React from 'react';

// One line under a weekly chart saying what its dates mean.
//
// Every weekly bucket in this app comes from _date_trunc_week() in
// routes/sales_pages.py — on PostgreSQL that is DATE_TRUNC('week', call_date), which
// returns ISO weeks, so the label is the MONDAY that OPENS the bucket, never the day it
// closes. Verified on syngentaind: every bucket label is a Monday, and the calls inside
// the 2026-07-06 bucket run 2026-07-06 to 2026-07-11.
//
// A date on its own cannot say whether it is the start or the end of its week, and that
// changes how every spike on the chart is read. Shared rather than repeated per page so
// all charts state the same convention.
//
// A daily axis needs no convention — a date means that date — so basis='daily' renders
// nothing rather than an obviously redundant line.

function WeekNote({ basis = 'weekly' }) {
  if (basis === 'daily') return null;
  return (
    <div style={{ fontSize: '11.5px', color: 'var(--text-lighter)', marginTop: '8px' }}>
      Each point is labelled with the <strong style={{ fontWeight: 600 }}>week starting</strong>{' '}
      date — the Monday that opens the week, through the following Sunday.
    </div>
  );
}

export default WeekNote;
